import * as React from 'react';
import { useSelector } from 'react-redux';
import { SearchResultsEmpty, SearchResultsLayout } from '../../../components/redesign/SearchResults';
import { selectPromoIds } from '../../../selectors/promos/promoIds';
import { ShowButtonContainer } from '../../ShowButtonContainer';
import { PromoItemContainer } from '../PromoItemContainer';

export const SearchResultsContainer: React.FC = () => {
  const promoIds = useSelector(selectPromoIds);

  return (
    <SearchResultsLayout showMoreButton={<ShowButtonContainer />}>
      {promoIds.length ? (
        promoIds.map(promoId => <PromoItemContainer promoId={promoId} key={promoId} />)
      ) : (
        <SearchResultsEmpty />
      )}
    </SearchResultsLayout>
  );
};
